import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BootstrapPriceForPrecisionComponent } from './components/bootstrap-price-for-precision/bootstrap-price-for-precision.component';

const routes: Routes = [{ path: '', component: BootstrapPriceForPrecisionComponent, pathMatch: 'full' }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PrizeForPrecisionRoutingModule { }
